import * as z from "zod";

export const clientsReqSchema = z.object({
  page: z.coerce.number().min(1).default(1),
  pageSize: z.coerce.number().min(1).max(100).default(10),
  name: z.string().optional(),
  id: z.string().optional(),
  sortByName: z.enum(["created"]).optional(),
  sortByOrder: z.enum(["asc", "desc"]).optional(),
});
